import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import googlePlayBadge from '../assets/branding/google-play-badge.png';
import appStoreBadge from '../assets/branding/app-store-badge.svg';

const platforms = [
  {
    key: 'android',
    name: 'Google Play',
    subtitle: 'Android',
    badge: googlePlayBadge,
    badgeAlt: 'Get it on Google Play',
  },
  {
    key: 'ios',
    name: 'App Store',
    subtitle: 'iOS',
    badge: appStoreBadge,
    badgeAlt: 'Download on the App Store',
  },
];

export default function Download() {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetch('/data/app_config.json')
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (!cancelled) setConfig(data);
      })
      .catch(() => {
        if (!cancelled) setConfig(null);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="min-h-screen" style={{ background: 'var(--brand-bg)' }}>
      <div className="mx-auto max-w-4xl px-4 py-14 sm:px-6 lg:px-8">
        <span className="pill">Get the Game</span>
        <h1 className="page-title section-gap">Download HiveFall</h1>
        <p className="page-subtitle max-w-2xl">
          HiveFall is coming to Android and iOS. Sign up for a free account and we'll have your progress ready to
          sync the moment you install.
        </p>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
          {platforms.map((p) => {
            const storeUrl = config?.[p.key]?.storeUrl;
            const isLive = typeof storeUrl === 'string' && storeUrl.trim().length > 0;

            return (
              <div key={p.key} className="relative rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                {!isLive && (
                  <span className="absolute right-4 top-4 rounded-full bg-slate-100 px-2.5 py-1 text-[10px] font-black uppercase tracking-wide text-slate-500">
                    Coming soon
                  </span>
                )}

                <p className="text-xs font-bold uppercase tracking-wide text-slate-400">{p.subtitle}</p>
                <p className="mt-0.5 font-black text-slate-900">{p.name}</p>

                <div className="mt-5 flex h-16 items-center">
                  {isLive ? (
                    <a
                      href={storeUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={p.badgeAlt}
                      className="inline-flex transition hover:opacity-90"
                    >
                      <img src={p.badge} alt={p.badgeAlt} className="h-14 w-auto" />
                    </a>
                  ) : (
                    <img
                      src={p.badge}
                      alt={`${p.badgeAlt} — coming soon`}
                      className="h-14 w-auto"
                      style={{ filter: 'grayscale(1)', opacity: 0.5 }}
                    />
                  )}
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-8 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
          <p className="font-black text-slate-900">Want a heads-up at launch?</p>
          <p className="mt-1 text-sm text-slate-500">
            Create a free HiveFall account now — your progress and settings will already be waiting for you when the
            app goes live.
          </p>
          <Link to="/register" className="btn btn-primary mt-4">
            Create a free account
          </Link>
        </div>

        <Link to="/" className="mt-8 inline-block text-sm font-bold text-[var(--brand-primary)] hover:underline">
          ← Back to home
        </Link>
      </div>
    </div>
  );
}
